export const AI_BLOCK_REGENERATION_TRIGGER_ID = 'ai-block-regeneration';
export const HIDE_ELEMENT_TRIGGER_ID = 'hide-element';
